<div v-bind:id="getSelector" class="printq_matrix_app">
  <div v-if="getMatrixConfiguration" v-html="getMatrixConfiguration"></div>
  <component
    v-bind:is="getLayout"
    v-if="!getIsLoading && !getNetworkError"
    v-bind:class="isMobileClass"
  ></component>
  <div v-if="!getIsLoading" class="matrix_portalContainer">
    <div
      class="matrix_portalElements"
      v-for="(item,index) in getPortalElements"
    >
      <component v-bind:is="item"></component>
    </div>
  </div>
  <appHiddenInputFields
    v-if="!getNetworkError && !getIsLoading && !getIsCimpressDefaultSelection && !getIsCimpressPreferredSelection"
  ></appHiddenInputFields>
  <appHiddenInputFieldsWithIds
    v-if="!getNetworkError && !getIsLoading && !getIsCimpressDefaultSelection && !getIsCimpressPreferredSelection"
  ></appHiddenInputFieldsWithIds>
  <appLoading
    v-show="!getNetworkError && (getIsLoading || getShowChangeOptionsLoader || getPersonalizeLoading || getPreview3DLoading)"
    :initialLoading="getIsLoading"
  />
  <appNetworkError v-if="getNetworkError" />
</div>
